/** 1. Tag it as a client component */
"use client";
import { storyblokInit, apiPlugin } from "@storyblok/react/rsc";
 

 
export default function StoryblokProvider({ children }) {
  return children;
}